<template>
    <div class="tableIngresos mt-5">
        <vs-row>
            <vs-col sm="12" v-if="users[0]">
                <vs-button
                    success
                    class="ml-auto"
                    @click="activeMasivo=!activeMasivo"
                >
                    Inscribir masivamente
                </vs-button>
            </vs-col>
            <vs-col sm="12" v-if="users[0]">
                <vs-button
                    warn
                    class="ml-auto"
                    @click="activeEliminarMasivamente=!activeEliminarMasivamente"
                >
                    <p v-for="ciclo in ciclosEscolares" :key="ciclo.id"><span v-if="ciclo.id == cicloEscolar">Eliminar registro académico del {{ciclo.text}}</span></p>
                </vs-button>
            </vs-col>
            <vs-col w="12">
                <masivo v-model="activeMasivo" :institucion="institucion" :cicloEscolar="cicloEscolar" :ciclosEscolares="ciclosEscolares" :grupo="grupo" @refreshTable="refreshTable"></masivo>
                <eliminar v-model="activeEliminar" @refreshTable="refreshTable" :row="selectedInfo" :institucion="institucion" :ciclo="cicloEscolar"></eliminar>
                <eliminar-masivo v-model="activeEliminarMasivamente" :usersOrden="usersOrden" :institucion="institucion" :cicloEscolar="cicloEscolar" :grupo="grupo" @refreshTable="refreshTable"></eliminar-masivo>
                <vs-input v-if="users != ''" class="ml-auto searchWidth" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
                <div style="max-width: 100%">
                    <h5 v-if="users.length > 0">Número total de alumnos: <strong>{{ users.length}}</strong></h5>
                     <vs-table
                        v-model="selected"
                        v-dragscroll="{ target: '.vs-table', active: true }"
                        >
                        <template #thead>
                        <vs-tr>
                            <!-- <vs-th style="width: 50px !important; ">
                                <vs-checkbox
                                    :indeterminate="selected.length == users.length" v-model="allCheck"
                                    @change="selected = $vs.checkAll(selected, users)"
                                />
                            </vs-th> -->
                            <vs-th sort @click="users = $vs.sortData($event ,users, 'nombre')">
                                Alumno
                            </vs-th>
                            <vs-th>
                                Estatus
                            </vs-th>
                            <vs-th>
                                Acciones
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in $vs.getSearch(usersOrden, search)"
                            :data="tr"
                            :is-selected="!!selected.includes(tr)"
                            style="vertical-align: top;"
                        >
                            <!-- <vs-td checkbox>
                            <vs-checkbox :val="tr" v-model="selected" />
                            </vs-td> -->
                            <vs-td>
                                    <p class="mb-0"><strong>{{tr.persona.full_name}}</strong></p>
                                    <p class="mb-0">Matrícula <strong>{{tr.persona.matricula}}</strong></p>
                                    <p class="mb-0"><strong>{{tr.nombre_ciclo}}</strong></p>
                                    <p class="mb-0"><i>{{tr.programa}}</i></p>
                                    <p class="mb-0">{{tr.atributo}}</p>
                            </vs-td>
                            <vs-td class="text-center">
                                <md-chip v-if="tr.programa === null" class="mb-1 fontMedium mini-chip col-yellow">
                                    <strong>
                                        <span>No inscrito</span>
                                    </strong>
                                </md-chip>
                                <md-chip v-else class="mb-1 fontMedium mini-chip col-green">
                                    <strong>
                                        <span>Inscrito</span>
                                    </strong>
                                </md-chip>
                            </vs-td>
                            <vs-td class="d-flex justify-content-center">
                                <vs-button
                                    icon
                                    color="warn"
                                    flat
                                    blank
                                    :href="ruta(tr.persona, tr.persona_id)"
                                >
                                   <i class="fas fa-external-link-alt mr-2" style="font-size: 0.9rem"></i> Incripcion académica
                                </vs-button>
                                <vs-button
                                    v-if="tr.programa !== null"
                                    icon
                                    color="danger"
                                    flat
                                     @click="activeEliminar = ! activeEliminar; selectedInfo = tr;"
                                >
                                    <i class="fas fa-trash-alt" style="font-size:0.8rem"></i>
                                </vs-button>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay información
                        </template>
                    </vs-table>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import eliminar from './modal/eliminar.vue'
import masivo from './modal/masivo.vue'
import EliminarMasivo from './modal/dar-baja.vue'
export default {
    props:[
        'users',
        'institucion',
        'cicloEscolar',
        'ciclosEscolares',
        'grupo'
    ],
    components: {
        eliminar,
        masivo,
        EliminarMasivo
    },
    data(){
        return{
            allCheck: false,
            selected: [],
            search: '',
            activeEliminar: false,
            activeEliminarMasivamente: false,
            selectedInfo: [],
            activeMasivo: false,
            usersOrden:[]
        }
    },
    methods:{
        ruta(persona, persona_id){
            if(persona.tipo == 'persona general'){
                return '/panel/alumno' + '/' + btoa(persona_id) + '/institucion/' + btoa(this.institucion) + '?valor=inscripcion-academica'
            }else{
                return '/panel/seguimiento' + '/' + btoa(persona.prospecto_id) + '/institucion/' + btoa(this.institucion) + '?valor=inscripcion-academica'
            }
        },
        refreshTable(){
            this.$emit('refreshTable')
        },
        getOrder(){
            const vue = this
            const orden = []
            for(var i = 0; i < this.users.length; i++){
                const ordenUser = this.users[i].persona.full_name
                orden.push(ordenUser)
            }
            orden.sort()
            const ordenFinal = []
            orden.forEach(i => {
                vue.users.forEach(j => {
                    if(i === j.persona.full_name){
                        ordenFinal.push(j)
                    }
                })
            })
            this.usersOrden = ordenFinal
        }
    },
    watch:{
        users(){
            this.getOrder()
        }
    }
}
</script>
<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .domicializar .vs-dialog{
        max-width: 95% !important;
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .docientos {
        width: 200px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
<style scoped>
    /* .vs-table-content {
        overflow-x: auto !important;
    } */
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
</style>

<style>
    .tableIngresos{
        width: 100% !important;
    }
    /* .tableIngresos .vs-table__th__content{
        justify-content: center;
    } */

    .cienCincuenta .vs-avatar__badge{
        font-size: 0.9rem !important;
        padding: 3px;
    }

</style>